import Input from "@/components/forms/Input";
import Select from "@/components/forms/Select";
import Header from "@/components/shared/Header";
import { FormikProvider, useFormik } from "formik";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Reorder, useDragControls } from "framer-motion";
import { Button } from "primereact/button";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";

export default function CreateEditFlow() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const isUpdate = state?.id ? true : false;

  const [saveLoading, setSaveLoading] = React.useState<boolean>(false);
  const listwrapper =
    "border-1 border-gray-400 p-4 flex flex-column gap-2 md:gap-3 border-round";

  const userList = ["Fred Adu", "John Doe", "Jane Doe", "Mary Doe"];

  const products = [
    {
      name: "Cashew",
      value: "Cashew",
    },
    {
      name: "Cocoa",
      value: "Cocoa",
    },
  ];

  const ctesList = [
    "Farm house ",
    "Warehouse",
    "Packaging",
    "Retailer",
    "Consumer",
    "Docks",
    "Transport",
    "Processing",
  ];

  const [ctes, setCtes] = React.useState<any>(
    state?.ctes ?? [
      "Farm house ",
      "Warehouse",
      "Packaging",
      "Retailer",
      "Consumer",
    ]
  );
  const dragControls = useDragControls();

  const formik = useFormik({
    initialValues: {
      name: state?.name ?? "",
      product: state?.product ?? "",
      observers: state?.observers ?? [],
      ctes: ctes,
    },
    validate: (values) => {
      const errors: any = {};

      if (!values.name) {
        errors.name = "Name of the flow is required";
      }

      if (!values.product) {
        errors.product = "Product of the flow is required";
      }

      return errors;
    },
    enableReinitialize: true,
    onSubmit: (values: any) => {
      if (isUpdate) {
        setSaveLoading(true);
        setTimeout(() => {
          setSaveLoading(false);
          toast.success("Flow updated successfully");
        }, 1000);
      } else {
        setSaveLoading(true);
        setTimeout(() => {
          setSaveLoading(false);
          toast.success("Flow created successfully");
        }, 1000);
      }
    },
  });

  const { values, handleSubmit } = formik;

  console.log(JSON.stringify(values, null, 2));

  return (
    <div>
      <Header
        onBack={() => navigate(-1)}
        title={isUpdate ? "Edit Traceability Flow" : "Create Traceability Flow"}
        extraAction="Save"
        extraActionIcon="pi pi-save"
        onExtraAction={() => handleSubmit()}
        extraActionLoading={saveLoading}
      />
      <ConfirmPopup />

      <FormikProvider value={formik}>
        <div className="flex flex-column gap-5 p-3 md:p-5">
          <section className={`${listwrapper} md:flex-row`}>
            <Input id="name" label="Name" placeholder="eg. Custom Flow 1" />
            <Select
              id="product"
              label="Product"
              options={products}
              optionLabel="name"
            />

            <div className="flex flex-column gap-2 p-fluid col">
              <label htmlFor="observers">Observers</label>

              <MultiSelect
                id="observers"
                value={values.observers}
                onChange={(e) => {
                  formik.setFieldValue("observers", e.value);
                }}
                options={userList}
                display="chip"
                placeholder="Select Cities"
                
                className="w-full"
              />
            </div>
          </section>

          <section className={`${listwrapper}`}>
            <div className="flex flex-column align-items-center gap-2">
              <label htmlFor="ctes">Critical Tracking Events</label>
              <Dropdown
                className="w-12 md:w-8"
                options={ctesList}
                onChange={(e) => {
                  // add item to ctes list but only if it doesn't already exist
                  if (!ctes.includes(e.value)) {
                    setCtes([...ctes, e.value]);
                  } else {
                    toast.warn("Item already exists in the list");
                  }
                }}
                filter
                placeholder="Select an item to add to the list"
                emptyMessage={
                  <div className="col p-fluid text-center">
                    <Button
                      label="ADD NEW CTE"
                      onClick={() => navigate("/admin/cte/new")}
                    />
                  </div>
                }
              />
            </div>

            <div className="flex flex-column align-items-center">
              <h4 className="mb-1">Critical Tracking Events</h4>
              <span>
                You can order the list by dragging the items up and down
              </span>

              <Reorder.Group
                axis="y"
                values={ctes}
                onReorder={setCtes}
                className="w-12 md:w-9 flex flex-column gap-3"
              >
                {ctes.map((cte: any, index: number) => {
                  return (
                    <Reorder.Item
                      key={cte}
                      value={cte}
                      id={cte}
                      dragControls={dragControls}
                      className="flex flex-row relative align-items-center justify-content-between gap-4 px-4 py-3  border-1 border-primary-300 hover:border-primary-500 border-round shadow-1 md:text-xl cursor-pointer"
                    >
                      <div className="flex gap-4 align-items-center">
                        <span>{index + 1}</span>
                        <i className="pi pi-bars cursor-move" />
                        <span>{cte}</span>
                      </div>
                      <Button
                        icon="pi pi-trash"
                        className="p-button-sm p-button-text"
                        onClick={(event) => {
                          confirmPopup({
                            target: event.currentTarget,
                            message:
                              "Are you sure you want to remove this cte?",
                            icon: "pi pi-exclamation-triangle",
                            accept: () => {
                              setCtes(ctes.filter((item: any) => item !== cte));
                            },
                            reject: () => {},
                          });
                        }}
                      />
                    </Reorder.Item>
                  );
                })}
              </Reorder.Group>
            </div>
          </section>
        </div>
      </FormikProvider>
    </div>
  );
}
